import DynamicPage from 'components/DynamicPage';

const About = () => {
  return(
    <DynamicPage url="/about-outsyde" />
  )
}

export default About;
